import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "index"];

  #dragged;

  connect() {
    this.#renumber();
  }

  start(event) {
    this.#dragged = this.#row(event.target);
  }

  over(event) {
    event.preventDefault();
    const over = this.#row(event.target);
    if (!over || !this.#dragged || over === this.#dragged) return;
    const rect = over.getBoundingClientRect();
    const after = event.clientY > rect.top + rect.height / 2;
    after ? over.after(this.#dragged) : over.before(this.#dragged);
    this.#renumber();
  }

  end() {
    this.#dragged = null;
  }

  up(event) {
    this.#move(this.#row(event.target), -1);
  }

  down(event) {
    this.#move(this.#row(event.target), 1);
  }

  #move(item, delta) {
    const items = this.itemTargets;
    const target = items.indexOf(item) + delta;
    if (target < 0 || target >= items.length) return;
    delta < 0 ? items[target].before(item) : items[target].after(item);
    this.#renumber();
  }

  #row(node) {
    return node.closest("[data-sortable-target='item']");
  }

  #renumber() {
    this.indexTargets.forEach((el, position) => {
      el.textContent = `${position + 1}.`;
    });
  }
}
